import React from "react";
import { useTranslation } from "react-i18next";

interface ErrorStateProps {
	error: Error | null;
}

const ErrorState: React.FC<ErrorStateProps> = ({ error }) => {
	const { t } = useTranslation();
	return (
		<div className="space-y-6">
			<div className="bg-red-50 border border-red-200 rounded-lg p-4">
				<div className="text-red-800 font-medium">
					{t("feature.courseBuilder.labs.createLab.errorLoadingEquipment")}
				</div>
				<div className="text-red-600 text-sm mt-1">{error?.message || String(error)}</div>
			</div>
		</div>
	);
};

export default ErrorState;
